import { IWorkflowTemplateVersionResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

export function useWorkflowTemplateVersion(
  workflowTemplateVersionId: string | null
) {
  return useSWR<IWorkflowTemplateVersionResponse>(
    workflowTemplateVersionId
      ? `${BASE_URL}/version/${workflowTemplateVersionId}`
      : null,
    SWRFetcher({ method: 'GET' })
  );
}
